<template>
  <div class="ui-copy-textarea">
    <ui-textarea
      ref="textareaRef"
      :label="label"
      :label-help="labelHelp"
      :rows="rows"
      :value="value"
      readonly
      :hide-details="2"
    />
    <v-tooltip v-model="copyTooltipShow" location="top">
      <template #activator="{ props: tooltipProps }">
        <ui-button
          v-bind="tooltipProps"
          class="copy-btn justify-content-center"
          icon="fas fa-copy"
          :text="copyButtonLabel || t('Copy')"
          style="width: 100%; margin: 0;"
          size="large"
          button-style="plain"
          :color="$colors.green"
          :content-color="$colors.green"
          @click="handleCopyScript"
        />
      </template>
      <span>{{ t('Copied!') }}</span>
    </v-tooltip>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useColors, useI18n } from '@/composables';

defineProps<{
  label?: string;
  copyButtonLabel?: string;
  rows?: number;
  value?: string;
  labelHelp?: string;
}>();

const { t } = useI18n();
const $colors = useColors();

const copyTooltipShow = ref(false);
const textareaRef = ref<{ $el?: HTMLElement } | null>(null);

const handleCopyScript = () => {
  const root = textareaRef.value?.$el;
  const textarea = root?.querySelector('textarea') as HTMLTextAreaElement | null;
  if (!textarea) {
    return;
  }
  textarea.select();
  document.execCommand('copy');
  copyTooltipShow.value = true;
  setTimeout(() => {
    copyTooltipShow.value = false;
  }, 2000);
};
</script>

<style lang="scss" scoped>
.ui-copy-textarea {
  padding-bottom: 16px;
}

.copy-btn :deep(.text) {
  text-transform: capitalize !important;
}
</style>
